/*
 * VigorX v2 — custom sort menu + one toolbar on collection pages.
 * The native <select name="sort_by"> stays in the form (Dawn's facets JS listens to its
 * input/change and re-renders the grid); we hide it visually and drive it from our own menu.
 * Dawn replaces the facets markup after every filter change, so a MutationObserver re-applies.
 */
(function () {
  'use strict';

  function build(select) {
    if (select.__vx) return;
    select.__vx = true;
    var field = select.closest('.facet-filters__field, .select') || select.parentElement;
    field.classList.add('vx-sort-host');

    var wrap = document.createElement('div');
    wrap.className = 'vx-sort';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vx-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var list = document.createElement('ul');
    list.className = 'vx-sort__list';
    list.setAttribute('role', 'listbox');

    function label() {
      var o = select.options[select.selectedIndex];
      btn.innerHTML = '<span class="vx-sort__k">Sortiraj</span><span class="vx-sort__v">' + (o ? o.text : '') + '</span>' +
        '<svg viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    [].forEach.call(select.options, function (o) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = o.value;
      li.textContent = o.text;
      if (o.selected) li.setAttribute('aria-selected', 'true');
      li.addEventListener('click', function () {
        select.value = o.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(); label();
      });
      list.appendChild(li);
    });
    function open() { wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); var s = list.querySelector('[aria-selected]') || list.firstChild; if (s) s.focus(); }
    function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) { e.preventDefault(); wrap.classList.contains('is-open') ? close() : open(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    list.addEventListener('keydown', function (e) {
      var items = [].slice.call(list.children), i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement.click(); }
      else if (e.key === 'Escape') { close(); btn.focus(); }
    });
    label();
    wrap.appendChild(btn);
    wrap.appendChild(list);
    field.parentElement.insertBefore(wrap, field.nextSibling);
  }

  function toolbar() {
    // column switcher into the same row as the filters
    var cols = document.querySelector('.vx-cols');
    var bar = document.querySelector('#FacetFiltersForm') || document.querySelector('.facets-container form') || document.querySelector('.facets-container');
    if (cols && bar && !bar.contains(cols)) { cols.classList.add('vx-cols--inbar'); bar.appendChild(cols); }
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('select[name="sort_by"]'), build);
    toolbar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  var root = document.querySelector('#main-collection-filters, .facets-container') && document.getElementById('MainContent');
  if (root && 'MutationObserver' in window) new MutationObserver(function () { boot(); }).observe(root, { childList: true, subtree: true });
})();
